var NotProcessedCandidatesController = /** @class */ (function () {
    /*@ngInject*/
    function NotProcessedCandidatesController($scope, $state, $timeout, $rootScope, $stateParams, GenericService, StorageService, DTOptionsBuilder, $resource) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.genericService = genericService;
        this.StorageService = StorageService;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.$resource = $resource;
    }
    NotProcessedCandidatesController.prototype.$onInit = function () {
        this.$stateParams = this.$transition$.params();
        this.query = { searchString: "" };
        this.resumeDetails = [];
        var cloudPath = 'http://martinfowler.com/ieeeSoftware/';
        this.$resource('assets/data/resumeData.json').query().$promise.then(function (resumeDetails) {
            this.resumeDetails = resumeDetails;
        });
        this.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withOption('bInfo', true)
            .withOption('searching', true)
            .withOption('lengthChange', false)
            .withOption('bFilter', true)
            .withOption('language', { zeroRecords: 'No records to display' })
            .withBootstrap();
    };
    // console.log('NotprocessedcandidatesController');
    // this.$scope.query = {
    //         searchString : ""
    //     };
    // $scope.resumeDetails = [];
    // var cloudPath='http://martinfowler.com/ieeeSoftware/';
    NotProcessedCandidatesController.prototype.resume = function () {
        var uri = cloudPath + 'whenType.pdf';
        var link = angular.element('<a href="' + uri + '" target="_blank"></a>');
        angular.element(document.body).append(link);
        link[0].click();
        link.remove();
    };
    ;
    //  genericService.getObjects(StorageService.get('baseurl') + NOTPROCESSEDCANDIDATESCONSTANTS.CONTROLLER.RESUME_DETAILS).then(function (data) {
    //     $scope.resumeDetails = data;
    //     var pdfvalue = $scope.resumeDetails.Recruiter;
    //     console.log('$scope.resumeDetailsList' + angular.toJson($scope.resumeDetails));
    // }, function (error) {
    //     console.log('error : ' + angular.toJson(error));
    // });
    // this.$resource('data/resumeData.json').query().$promise.then(function(resumeDetails) {
    //         $scope.resumeDetails = resumeDetails;
    //     });               
    // $scope.dtOptions = DTOptionsBuilder.newOptions()
    //     .withPaginationType('full_numbers')
    //     .withOption('bInfo',true)
    //     .withOption('searching',false)
    //     .withOption('lengthChange',false);
    // $scope.dtOptions = DTOptionsBuilder.newOptions()
    //     .withPaginationType('full_numbers')
    //     .withOption('bInfo',true)
    //     .withOption('searching',true)
    //     .withOption('lengthChange',false)
    //     .withOption('bFilter', true)
    //     .withOption('language', {zeroRecords: 'No records to display'})
    //     .withBootstrap(); 
    NotProcessedCandidatesController.prototype.search = function (row) {
        return ((angular.lowercase(row.FirstName) || '').indexOf(angular.lowercase($scope.query.searchString) || '') !== -1 ||
            (angular.lowercase(row.LastName) || '').indexOf(angular.lowercase($scope.query.searchString) || '') !== -1 ||
            (angular.lowercase(row.Email) || '').indexOf(angular.lowercase($scope.query.searchString) || '') !== -1 ||
            (angular.lowercase(row.Ph) || '').indexOf(angular.lowercase($scope.query.searchString) || '') !== -1);
    };
    ;
    return NotProcessedCandidatesController;
}());
export { NotProcessedCandidatesController };
NotProcessedCandidatesController.$inject = ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'GenericService', 'StorageService', 'DTOptionsBuilder', '$resource'];
// import * as TEMPLATE from './not-processed-candidates.html';
import * as TEMPLATE from 'raw-loader!./not-processed-candidates.html';
export var NotProcessedCandidatesComponent = {
    selector: 'notProcessedCandidates',
    component: {
        bindings: {
            $transition$: '<'
        },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/notprocessedcandidates/not-processed-candidates.html',
        controller: NotProcessedCandidatesController
    }
};
//# sourceMappingURL=not-processed-candidates.component.js.map